exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-container[data-v-795ac6e4]{position:absolute;left:0;right:0;display:flex;justify-content:center;align-items:center;height:48px;background-color:#2ecc71}.notification-container p[data-v-795ac6e4]{color:#fff;font-family:Open Sans,sans-serif;font-size:16px;font-weight:600;letter-spacing:0;line-height:24px;margin:0}.slide-in-fade-enter-active[data-v-795ac6e4]{transition:all .3s ease}.slide-in-fade-leave-active[data-v-795ac6e4]{transition:all .8s cubic-bezier(1,.5,.8,1)}.slide-in-fade-enter[data-v-795ac6e4],.slide-in-fade-leave-to[data-v-795ac6e4]{opacity:0}", ""]);

// exports
